import React, { Suspense } from 'react';

const LoadableComponent = React.lazy(() => import('./Reports'));

function LoadableReports() {
  return (
    <Suspense fallback={<div />}>
      <LoadableComponent />
    </Suspense>
  );
}

export default LoadableReports;
